import {
  FAKE,
  REAL,
  registerDependency
} from 'components/shared/dependency-injection/dependency-injection.js'

export type Fetcher = { fetch: (url: URL, init?: RequestInit | undefined) => Promise<Response> }

export class RealFetcher implements Fetcher {
  fetch = (url: URL, init?: RequestInit | undefined) => fetch(url, init)
}

export type FakeRequests = { path: string, init: RequestInit | undefined }[]
export type FakeResponse<T = any> = { data: T, init?: ResponseInit }
export type FakeResponses = { [path: string]: FakeResponse }

export class FakeFetcher implements Fetcher {
  public requests: FakeRequests = []
  public responses: FakeResponses = {}

  public fetch = async (url: URL, init?: RequestInit): Promise<Response> => {
    const fullPath = url.pathname + url.search
    this.requests.push({ path: fullPath, init })
    const { data, init: responseInit } = this.responses[fullPath] ?? this.responses[url.pathname] ?? { data: null, init: { status: 404 } }
    return data ? Response.json(data, responseInit) : new Response(null, responseInit)
  }
}

export let fetcher!: Fetcher
registerDependency({
  [REAL]: () => fetcher = new RealFetcher(),
  [FAKE]: () => fetcher = new FakeFetcher(),
})
